import React, { useEffect, useRef, useState } from "react";
import * as api from "helper/helper";
import CardFilter from "../CardFilter";

import { FaPlus } from "react-icons/fa6";
import CreateAsociados from "../Asociados/CreateAsociados";
import AddressView from "../Address/AddressView";
import BonificacionesTable from "./BonificacionesTable";
import { useFormik } from "formik";
import { scheduleHoursFormValidate } from "../../../../helper/validate";
import toast from "react-hot-toast";
import { format, isAfter, parse, toDate } from "date-fns";
import invalidClass from "../../helperFunctions/helpers";
import LoadingButton from "../LoadingButton/LoadingButton";

function BonificacionesMain() {
  const modalRef = useRef();
  const tableRef = useRef();
  //const buttonModalRef = useRef();
  const buttonModalRef2 = useRef();
  const buttonModalEditRef = useRef();
  const addressView = useRef(null);
  const createAsociadosRef = useRef();

  const [pendings, setPendings] = useState(null);
  const [limitsPendings, setLimitsPendings] = useState([]);
  const [schedule, setSchedule] = useState(null);
  //const [filter, setFilter] = useState("Hoy");
  const [modalData, setModalData] = useState(null);
  const [editAddress, setEditAddress] = useState(null);

  const [isActualizando, setIsActualizando] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  function saveAddress(event) {
    const value = addressView.current.getValue();
    addressView.current.clear();
    console.log(value);

    let newModalData = { ...modalData };
    if (modalData == null) {
      newModalData = createAsociadosRef.current.getValue();
    }

    if (value.id === 0) {
      let newId = newModalData.direcciones.reduce(
        (accumulator, currentValue) =>
          accumulator < currentValue.id ? accumulator : currentValue.id,
        0,
      );
      console.log(" --- " + newId);
      value.id = newId - 1;
      newModalData.direcciones.push(value);
    } else {
      const index = newModalData.direcciones.findIndex(
        (item) => item.id === value.id,
      );
      if (index !== -1) {
        newModalData.direcciones.splice(index, 1, value);
      }
    }

    setModalData(newModalData);

    //console.log(modalData);
    console.log("saveAdd");
  }

  function saveChanges(event) {
    //console.log(modalData);

    setIsActualizando(true);
    tableRef.current.submit();
    setIsActualizando(false);

    console.log("save CHANGES");
  }

  const childToParent = (data) => {
    //  setAddressViewCurrent(data);
    //setModalData(data);
    //  buttonModalRef.current.click();
  };

  function newEditModal(item) {
    buttonModalRef2.current.click();
    setEditAddress(item);
  }

  function reloadAll() {
    fetchData();
  }

  function loadItem(item) {
    console.log(modalRef);

    /*modalRef.current.style.display += "block";
    modalRef.current.classList.add("show");
    setOpenModal(true);*/
    setModalData(item);

    buttonModalEditRef.current.click();
  }

  /*  function validateTimeInput(input) {
    if (input == null) return;

    console.log(input.value);

    var regex = /^([01][0-9]|2[0-3]):[0-5][0-9]$/; // Regular expression for HH:MM format
    if (!regex.test(input.value)) {
      alert("Please enter time in HH:MM .");
      input.value = ""; // Clear the input field if the format is incorrect
    }
  }*/

  const tryApprove = async (item) => {
    fetchData();
  };

  let initialValues = {
    id: 0,
    horaInicial: "00:00:00",
    horaFinal: "00:00:00",
    activarDomingo: false,
  };

  const formik = useFormik({
    initialValues: { ...initialValues },
    enableReinitialize: false,
    validate: () => scheduleHoursFormValidate,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      /*{
        "nombre": "default",
        "horaInicial": "2024-11-16T23:47:25.990Z",
        "horaFinal": "2024-11-16T23:47:25.990Z"
      }*/

      const todayInicialDate = parse(
        formik.values.horaInicial,
        "HH:mm:ss",
        new Date(),
      );
      const todayFinDate = parse(
        formik.values.horaFinal,
        "HH:mm:ss",
        new Date(),
      );

      const todayInicial = format(todayInicialDate, "yyyy-MM-dd'T'HH:mm:ss");
      const todayFin = format(todayFinDate, "yyyy-MM-dd'T'HH:mm:ss");

      let payload = {
        nombre: "default",
        horaInicial: todayInicial,
        horaFinal: todayFin,
        activarDomingo: values.activarDomingo,
      };

      let responseUpdate = await api
        .updateConfiguraciones(payload)
        .catch((e) => {
          console.log(e);
          toast.error("Error al actualizar");
        });
      if (responseUpdate) {
        toast.success("Horario actualizado");
        //  setPendings(responseUpdate);
      }
    },
  });

  const fetchData = async () => {
    setIsLoading(true);
    let responseResetPassword = await api.promocionesConfigurar().catch((e) => {
      console.log(e);
    });
    if (responseResetPassword) {
      setPendings(responseResetPassword.data);
    }

    setIsLoading(false);

    /*  let responseChangeLevelCredit = await api
      .asociadosSolicitudes()
      .catch((e) => {
        console.log(e);
      });
    if (responseChangeLevelCredit) {
      setLimitsPendings(responseChangeLevelCredit.data);
    }

    // 1 es default
    let horarioDefaultId = 1;
    let configuracionesResponse = await api
      .configuraciones(horarioDefaultId)
      .catch((e) => {
        console.log(e);
      });
    if (configuracionesResponse) {
      const configData = configuracionesResponse.data;
      configData.horaInicial = toDate(configData.horaInicial);
      //  "yyyy-MM-dd'T'HH:mm:ss"
      configData.horaFinal = toDate(configData.horaFinal);

      console.log(
        isAfter(toDate("2025-01-01T10:33:21"), toDate("2025-01-01T10:30:21"))
      );

      //  setSchedule(response);
      setSchedule(configData);

      initialValues = formik.initialValues;
      initialValues.horaInicial = format(configData.horaInicial, "HH:mm:ss");
      initialValues.horaFinal = format(configData.horaFinal, "HH:mm:ss");
      initialValues.activarDomingo = configData.activarDomingo;
      formik.initialValues = { ...initialValues };
      formik.setFieldValue("horaInicial", initialValues.horaInicial);
      formik.setFieldValue("horaFinal", initialValues.horaFinal);
      formik.setFieldValue("activarDomingo", initialValues.activarDomingo);
      */
    //}
  };

  useEffect(() => {
    fetchData();
    return () => {};
  }, []);

  if (formik) {
    console.log(formik.getFieldProps("horaInicial"));
  }

  function reloadCredit() {
    fetchData();
  }

  return (
    <>
      <div className="card recent-sales overflow-auto">
        {/*<CardFilter filterChange={handleFilterChange} />*/}
        <div className="card-body">
          <h5 className="card-title">
            <span></span>
            <span hidden>
              <button
                ref={buttonModalRef2}
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop3"
              >
                <div>
                  <FaPlus />
                  MODI
                </div>
              </button>
            </span>
          </h5>

          {/*<SearchBar />

        <div className="row">
          <div className="col-3">
            <span>Ordenar</span>
            <select className="form-select" aria-label="Default select example">
              <option selected>Selecciona Sucursal</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>
          <div className="col-3">
            <span>Ordenar</span>
            <select className="form-select" aria-label="Default select example">
              <option selected>Selecciona responsable</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>
        </div>*/}

          <BonificacionesTable
            ref={tableRef}
            items={pendings}
            openItem={loadItem}
            tryApprove={tryApprove}
            reload={reloadAll}
            isLoading={isLoading}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: "20px",
          }}
        >
          <LoadingButton
            style={{ height: "38px" }}
            onClick={async (e) => {
              //  saveMetaPorNivel();
              saveChanges();
            }}
            text={"Actualizar"}
            loadingText={"Actualizando..."}
            isLoading={isActualizando}
          />
        </div>

        <div
          ref={modalRef}
          className="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <CreateAsociados
            ref={createAsociadosRef}
            item={modalData}
            callNewEditModal={newEditModal}
            reloadAsociados={reloadAll}
          />
        </div>

        <div
          className="modal fade"
          id="staticBackdrop3"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdrop3Label"
          aria-hidden="true"
          style={{ zIndex: 1600 }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="staticBackdrop3Label">
                  {editAddress && Object.keys(editAddress).length > 0
                    ? "Editar"
                    : "Crear"}{" "}
                  dirección
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <AddressView
                  ref={addressView}
                  item={editAddress}
                  childToParent={childToParent}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                >
                  Cancelar
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                  onClick={(e) => saveAddress(e)}
                >
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Modal title
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">...</div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BonificacionesMain;
